import React, { useState } from "react";
import MobileApplied from "./MobileApplied";
import MobileShortlisted from "./MobileShortlisted";
import MobileSelected from "./MobileSelected";
import MobileAppointed from "./MobileAppointed";
import MobileCancelled from "./MobileCancelled";
import "./dash.css";
import MobileDashSub from "./MobileDashSub";

const DashTutorMobile = () => {
  const [activeTab, setActiveTab] = useState(0); // 0 is the index for the first tab

  const renderTabContent = () => {
    switch (activeTab) {
      case 0:
        return <MobileDashSub/>;
      case 1:
        return <MobileApplied></MobileApplied>;
      case 2:
        return <MobileShortlisted></MobileShortlisted>;
      case 3:
        return <MobileSelected></MobileSelected>;
      case 4:
        return <MobileAppointed></MobileAppointed>;
      case 5:
        return <MobileCancelled></MobileCancelled>;
      default:
        return null;
    }
  };

  return (
    <div className="bg-green-700 h-screen ">
      <h1 className="text-xl  text-left py-4 font-signika text-white px-4">
        Dashboard
      </h1>

      <div className=" flex justify-between flex-row gap-3 px-4">
        <button
          onClick={() => setActiveTab(1)}
          className={
            activeTab === 1
              ? "textSizeMin font-spaceMono text-white bg-green-900 px-2 py-2 rounded"
              : "textSizeMin font-spaceMono text-white bg-green-600 px-2 py-2 rounded"
          }
        >
          Applied
        </button>
        <button
          onClick={() => setActiveTab(2)}
          className={
            activeTab === 2
              ? "textSizeMin font-spaceMono text-white bg-green-900 px-2 py-2 rounded"
              : "textSizeMin font-spaceMono text-white bg-green-600 px-2 py-2 rounded"
          }
        >
          Shortlisted
        </button>
        <button
          onClick={() => setActiveTab(3)}
          className={
            activeTab === 3
              ? "textSizeMin font-spaceMono text-white bg-green-900 px-2 py-2 rounded"
              : "textSizeMin font-spaceMono text-white bg-green-600 px-2 py-2 rounded"
          }
        >
          Selected
        </button>
        <button
          onClick={() => setActiveTab(5)}
          className={
            activeTab === 5
              ? "textSizeMin font-spaceMono text-white bg-green-900 px-2 py-2 rounded"
              : "textSizeMin font-spaceMono text-white bg-green-600 px-2 py-2 rounded"
          }
        >
          Cancelled
        </button>
      </div>
      <div>{renderTabContent()}</div>
    </div>
  );
};

export default DashTutorMobile;
